export const readImage = (file, callback) => {
    if (file.type && !file.type.startsWith("image/")) {
        return;
    }

    const reader = new FileReader();
    reader.addEventListener("load", (event) => {
        callback(event.target.result);
    });
    reader.readAsDataURL(file);
}